// React
import React, { Component } from "react";

// React Router
import { Link } from 'react-router-dom';

import { LoginRoutes } from '../../Routes';

import './infopages.css';

class Info extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            views : {
                "activate" : {
                    message : 'Activating Account..',
                    subMessage : 'Hang Tight..',
                    buttonText : 'Return To Login',
                    buttonLink : '/login'
                },
                "success" : {
                    message : 'Signup Success.',
                    subMessage : 'An Activation Email Will Arrive Shortly.',
                    buttonText : 'Return To Login',
                    buttonLink : '/login'
                }
            },
            done : false
            
        };
    }

    

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('Info.componentDidMount()');

        // Validate User Account
        if(this.props.view === "activate")
            this.activateUser();

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Validate a User's new account
    activateUser() {

        //console.log('Info.validateUser()');

        var username = this.props.match.params.username;

        LoginRoutes.activateUser(username)
            .then( (success) => {

                this.setState((prev, props) => {
                    return {
                        views : {
                            activate : {
                                message : 'Account Activated.',
                                subMessage : 'Everything is ready.',
                                buttonText : 'Return To Login',
                                buttonLink : '/login'
                            }
                        }
                    }
                });

            }).catch( (error) => {

                this.setState((prev, props) => {
                    return {
                        views : {
                            activate : {
                                message : 'Error Activating Account.',
                                subMessage : 'Please Contact Us At accounts@yety.io For Help.',
                                buttonText : 'Sorry About This',
                                buttonLink : '/login'
                            }
                        }
                    }
                });
                
            });

    }

    // Gets the current screen size
    getScreenSize() {
        return { width: window.innerWidth, height: window.innerHeight };
    }


/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Info.render()');

    const view = this.props.view;

    return (
        <div className="page-container">

          <div className="page-content">

            <div className="content-wrapper">

              {/*-----------  Page header -----------*/}

              {/*-----------  Content Area -----------*/}
              <div className="content">

                {/*-----------  Top Row  -----------*/}
                <div className="row">
                    
                    <div className="logo-box col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12 col-xs-12 top-10">
                        <img className="logo" src="/assets/img/logo.svg" alt=""></img>
                    </div>
                </div>

                <div className="row">
                    
                    <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12 col-xs-12 top-5">
                        <div className="message">{this.state.views[view].message}</div>
                    </div>
                </div>

                <div className="row">

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-5">
                        <div className="sub-message">{this.state.views[view].subMessage}</div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-5">
                        <Link to={this.state.views[view].buttonLink} type="button" className="btn btn-raised bg-purple-400 legitRipple">
                            <i className="icon-atom position-left"></i><span>{this.state.views[view].buttonText}</span>
                        </Link>
                    </div>

                </div>

              </div>

            </div>

          </div>

        </div>
    );
  }
}

export default Info;





// WEBPACK FOOTER //
// ./src/Views/InfoPages/Info.js